import { createStore, applyMiddleware, compose } from "redux";
import { createWrapper } from "next-redux-wrapper";
import { composeWithDevTools } from "redux-devtools-extension";
import thunk from "redux-thunk";
import rootReducer from "./index";
import { persistStore } from "redux-persist";

const dev = process.env.NODE_ENV !== "production";
let enhancer;
const mware = applyMiddleware(thunk);

if (dev) {
  enhancer = compose(composeWithDevTools(mware));
} else {
  enhancer = compose(mware);
}

export const store = createStore(rootReducer, enhancer);
export const persistor = persistStore(store);

const wrapper = createWrapper(() => store, { debug: false });

export default wrapper;
